/** Header/footer and section dividers — matches logged-in app chrome (`border-border/70`). */
export const MARKETING_DIVIDER_BORDER = 'border-border/70'

/** Same as {@link MARKETING_DIVIDER_BORDER} with `max-md:` prefix (Tailwind must see full class strings). */
export const MARKETING_DIVIDER_BORDER_MAX_MD = 'max-md:border-border/70'

/** Elevated cards on public landing below-fold sections. */
export const LANDING_CARD_SURFACE =
  'rounded-xl border-0 bg-card p-5 shadow-[var(--shadow-border)] dark:bg-card'

export const LANDING_CHIP_SURFACE =
  'rounded-[var(--radius-button)] border border-border bg-card px-4 py-2 text-sm text-foreground dark:bg-card'
